import React from 'react';
import { useParams } from 'react-router-dom';
import Navbar from './Navbar';
import MovieSmall from '../assets/movie-pic.jpeg';
import useSingleMovie from '../hooks/useSingleMovie';
import { TMDB_IMG_URL } from '../utils/constant';
import { useSelector, useDispatch } from 'react-redux'; // Redux imports
import { CiPlay1 } from 'react-icons/ci';
import { getId, setOpen } from '../redux/movieSlice';
import Footer from './Footer';

const SingleMovie = () => {
    const { id } = useParams(); // Get the movie ID from the URL
    const dispatch = useDispatch(); // Initialize dispatch
    const movieData = useSelector((state) => state.movie.singleMovieDetail); // Access single movie data from Redux store
    const credits = useSelector((state) => state.movie.credits); // Access credits data from Redux store

    useSingleMovie(id); // Fetch single movie data using the custom hook

    // Handle loading state for both movie data and credits
    if (!movieData || !credits) {
        return <div className="text-white text-center">Loading...</div>; // Loading state
    }

    const handleOpen = () => {
        dispatch(getId(id)); // Set movie ID in the store
        dispatch(setOpen(true)); // Open the modal or related action
    };

    return (
        <>
            <Navbar />
            <section>
                <div className="mx-auto max-w-sm sm:max-w-sm md:max-w-md lg:max-w-[1211px]">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-black p-5 rounded-lg">
                        {/* Left Section */}
                        <div>
                            <div className="relative">
                                <div className="flex flex-col sm:flex-row gap-4">
                                    <div className="relative w-full sm:w-40 cursor-pointer" onClick={handleOpen}>
                                        <img
                                            src={
                                                movieData.poster_path
                                                    ? `${TMDB_IMG_URL}${movieData.poster_path}`
                                                    : '/fallback-image.jpg'
                                            }
                                            alt={movieData.title}
                                            className="w-full h-full rounded-lg"
                                        />
                                        <CiPlay1
                                            size="40px"
                                            className="absolute bg-[rgba(243,243,243,0.45)] p-2 rounded-full text-white top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                                        />
                                    </div>
                                    <div className="sm:ml-4 mt-4 sm:mt-0">
                                        <h2 className="font-bold text-[26px] text-white">{movieData.title}</h2>
                                        <p className="pt-2 text-white">
                                            Rating: {movieData.vote_average ? movieData.vote_average.toFixed(1) : 'N/A'}
                                        </p>
                                        <p className="pt-2 text-white">
                                            Runtime: {movieData.runtime ? movieData.runtime : 'N/A'} min
                                        </p>
                                        <p className="pt-2 text-white">
                                            Release Date: {movieData.release_date || 'N/A'}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-4">
                                <h2 className="font-bold text-[26px] text-white">Overview</h2>
                                <p className="pt-2 text-white">{movieData.overview || 'No overview available.'}</p>
                            </div>
                        </div>

                        {/* Right Section */}
                        <div>
                            <img
                                src={
                                    movieData.backdrop_path
                                        ? `${TMDB_IMG_URL}${movieData.backdrop_path}`
                                        : '/fallback-image.jpg'
                                }
                                alt={movieData.title}
                                className="w-full h-[300px] sm:h-[400px] object-cover rounded-lg"
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* Cast Section */}
            <div className="px-8">
                <h1 className="text-white text-3xl py-3">Cast</h1>
                <div className="flex overflow-x-auto no-scrollbar cursor-pointer">
                    {credits.cast &&
                        credits.cast.map((castMember) => (
                            <div className="flex items-center pr-4" key={castMember.id}>
                                <div className="w-52">
                                    <img
                                        src={
                                            castMember.profile_path
                                                ? `${TMDB_IMG_URL}${castMember.profile_path}`
                                                : MovieSmall
                                        }
                                        alt={castMember.name}
                                        className="w-full h-[200px] object-cover rounded-lg"
                                    />
                                    <h6 className="text-white pt-2">{castMember.name}</h6>
                                    <p className="text-white">
                                        Character: {castMember.character || 'N/A'}
                                    </p>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
            <Footer/>
        </>
    );
};

export default SingleMovie;
